import type { TranslationDict } from "@repo/core";

export const it: TranslationDict = {
  // —— uiKeys ——
  "type.income": "Entrata",
  "type.expense": "Uscita",
  "type.transfer": "Trasferimento",

  "person.household": "Famiglia",
  "person.personal": "Personale",
  "person.partner": "Partner",
  "person.sideHustle": "Entrate extra",

  "method.snowball": "Palla di neve",
  "method.avalanche": "Valanga",

  "tx.log": "Registro transazioni",
  "tx.search": "Cerca…",
  "tx.allTypes": "Tutti i tipi",
  "tx.allCategories": "Tutte le categorie",
  "tx.fromDate": "Data inizio",
  "tx.toDate": "Data fine",
  "tx.minAmount": "Min",
  "tx.maxAmount": "Max",
  "tx.clearFilters": "Cancella",
  "tx.entries": "{n} voci",
  "tx.noMatch": "Nessuna transazione corrisponde ai filtri.",
  "tx.loadMore": "Carica altro ({n} rimanenti)",
  "tx.importCsv": "Importa CSV",
  "tx.csv": "CSV",
  "tx.add": "Aggiungi",
  "tx.edit": "Modifica",
  "tx.delete": "Elimina",
  "tx.editAria": "Modifica transazione",
  "tx.deleteAria": "Elimina transazione",
  "tx.deleteConfirm": "Eliminare questa transazione?",
  "tx.col.date": "Data",
  "tx.col.type": "Tipo",
  "tx.col.amount": "Importo",
  "tx.col.category": "Categoria",
  "tx.col.account": "Conto",
  "tx.col.person": "Persona",
  "tx.col.notes": "Note",
  "tx.account": "Conto",
  "tx.category": "Categoria",
  "tx.chooseAccount": "— Scegli conto —",

  "txModal.edit": "Modifica transazione",
  "txModal.new": "Nuova transazione",
  "txModal.editSub": "Aggiorna una voce esistente",
  "txModal.newSub": "Registra una spesa o un'entrata",
  "txModal.type": "Tipo di transazione",
  "txModal.amount": "Importo",
  "txModal.date": "Data",
  "txModal.person": "Persona / Membro",
  "txModal.personPh": "Famiglia, Marco, Sara…",
  "txModal.category": "Categoria",
  "txModal.chooseCategory": "— Scegli categoria —",
  "txModal.notes": "Note / Descrizione",
  "txModal.notesPh": "Dettagli opzionali…",
  "txModal.recurring": "Transazione ricorrente",
  "txModal.freq.weekly": "Settimanale",
  "txModal.freq.monthly": "Mensile",
  "txModal.freq.custom": "Intervallo personalizzato",
  "txModal.intervalDays": "Giorni tra ogni",
  "txModal.recurringHelp":
    "Le voci future vengono generate automaticamente. Puoi saltare una singola occorrenza in seguito.",
  "txModal.series": "Serie ricorrente",
  "txModal.scopeOne": "Solo questa occorrenza",
  "txModal.scopeSeries": "Intera serie (questa e future)",
  "txModal.skip": "Salta questa occorrenza",
  "txModal.skipConfirm":
    "Saltare solo questa occorrenza? Il resto della serie resta.",
  "txModal.saving": "Salvataggio…",
  "txModal.update": "Aggiorna transazione",
  "txModal.save": "Salva transazione",

  "csv.title": "Importa CSV",
  "csv.intro":
    "Associa le colonne dell'estratto bancario, anteprima le righe, poi importa.",
  "csv.mapping": "Mappatura colonne",
  "csv.mappingHint":
    "A sinistra: nome colonna nel CSV. A destra: assegna ogni colonna a un campo BudgetOS.",
  "csv.preview": "Anteprima ({ok}/{total} valide)",
  "csv.ignore": "Ignora",
  "csv.ok": "OK",
  "csv.importing": "Importazione…",
  "csv.importN": "Importa {n} righe",
  "csv.readError": "Impossibile leggere le intestazioni CSV.",
  "csv.badDate": "Data non valida",
  "csv.badAmount": "Importo non valido",
  "csv.noCategory": "Nessuna categoria",
  "csv.needAccount":
    "Aggiungi il primo conto in Impostazioni prima di importare — le righe CSV devono essere collegate a un conto.",

  "cal.subtitle": "Monitora spese giornaliere e serie senza spese",
  "cal.prev": "Mese precedente",
  "cal.next": "Mese successivo",
  "cal.streak": "Serie senza spese",
  "cal.streakSub": "giorni consecutivi",
  "cal.noSpendDays": "Giorni senza spese",
  "cal.thisMonth": "questo mese",
  "cal.spendDays": "Giorni con spese",
  "cal.active": "attivi",
  "cal.totalSpent": "Totale speso",
  "cal.avgDay": "media {amount}/giorno",
  "cal.title": "Calendario spese (clicca un giorno per i dettagli)",
  "cal.legend.noSpend": "Senza spese",
  "cal.legend.spend": "Giorno con spese",
  "cal.legend.today": "Oggi",
  "cal.badge.noSpend": "Giorno senza spese",
  "cal.badge.spent": "Speso:",
  "cal.badge.income": "Entrata:",
  "cal.cleanTitle": "Serie finanziaria pulita!",
  "cal.cleanBody": "Nessuna spesa registrata in questo giorno. Continua così!",
  "cal.txOnDate": "Transazioni in questa data ({n})",
  "cal.addForDate": "Aggiungi transazione per questa data",

  "debt.title": "Calcolatore di estinzione debiti",
  "debt.totalDebt": "Debito totale",
  "debt.totalInterest": "Interessi totali",
  "debt.debtFreeDate": "Data senza debiti",
  "debt.apr": "{n}% TAN",
  "debt.currentBalance": "saldo attuale",
  "debt.minPay": "Rata min.",
  "debt.extra": "Extra",
  "debt.interest": "Interessi",
  "debt.months": "{n} mesi",
  "debt.viewSchedule": "Vedi piano di ammortamento completo",
  "debt.hideSchedule": "Nascondi piano di ammortamento",
  "debt.col.month": "Mese",
  "debt.col.payment": "Pagamento",
  "debt.col.principal": "Capitale",
  "debt.col.interest": "Interessi",
  "debt.col.balance": "Saldo",
  "debt.balance": "Saldo ({symbol})",
  "debt.rate": "Tasso (%)",
  "debt.minPayment": "Pagamento minimo",
  "debt.extraPayment": "Pagamento extra",
  "debt.chartTitle": "Saldo debiti combinato nel tempo",
  "debt.payoffOrderSnowball": "Ordine di estinzione (saldo minore prima)",
  "debt.payoffOrderAvalanche": "Ordine di estinzione (tasso più alto prima)",
  "debt.exportSchedule": "Esporta piano",
  "debt.edit": "Modifica",

  "mb.exportMonth": "Esporta questo mese",
  "mb.income": "Entrate",
  "mb.expenses": "Uscite",
  "mb.target": "obiettivo {amount}",
  "mb.budget": "budget {amount}",
  "mb.allocation": "Allocazione mensile delle spese",
  "mb.byGroup": "Per gruppo (Necessità / Desideri / Risparmi)",
  "mb.topExpense": "Principali categorie di spesa",
  "mb.incomeSources": "Fonti di entrata",

  "rule.netIncome": "Reddito netto mensile",
  "rule.distribution": "Distribuzione 50/30/20",
  "rule.breakdown": "Dettaglio",
  "rule.visual": "Confronto visivo",
  "rule.targetPct": "Obiettivo: {n}% del reddito",
  "rule.actual": "Effettivo:",
  "rule.unclassified": "{n}% del reddito non classificato o non speso",
  "rule.status.ahead": "Davanti all'obiettivo",
  "rule.status.onTrack": "In linea",
  "rule.status.below": "Sotto l'obiettivo",
  "rule.status.over": "Oltre il budget",
  "rule.status.under": "Sotto l'obiettivo",

  "sf.title": "Fondi obiettivo",
  "sf.addFund": "Aggiungi fondo",
  "sf.totalSaved": "Totale risparmiato",
  "sf.saved": "Risparmiato",
  "sf.target": "Obiettivo",
  "sf.remaining": "Rimanente",
  "sf.monthsLeft": "Mesi rimasti",
  "sf.needMonth": "Serve/mese",
  "sf.contribute": "+ Contribuisci",
  "sf.contributePrompt": "Aggiungi a \"{name}\"\nAttuale: {current}\nImporto:",
  "sf.deleteConfirm": "Eliminare \"{name}\"?",
  "sf.due": "Scade {date}",
  "sf.newTitle": "Nuovo fondo obiettivo",
  "sf.name": "Nome",
  "sf.icon": "Icona",
  "sf.namePh": "es. Vacanze",
  "sf.fundIcon": "Icona del fondo",
  "sf.targetAmount": "Obiettivo",
  "sf.targetDate": "Data obiettivo",
  "sf.alreadySaved": "Già risparmiato",
  "sf.color": "Colore",
  "sf.empty": "Nessun fondo ancora. Aggiungine uno per iniziare a risparmiare!",

  "cf.title": "Flusso di cassa mensile",
  "cf.titleYear": "Flusso di cassa mensile · {year}",
  "cf.netSurplus": "Avanzo netto",
  "cf.income": "Entrate",
  "cf.expenses": "Uscite",
  "cf.expense": "Uscita",
  "cf.netFlow": "Flusso netto",
  "cf.pctSaved": "{n}% risparmiato",
  "cf.mode.bars": "Barre raggruppate",
  "cf.mode.flow": "Flusso fluido",
  "cf.mode.net": "Avanzo netto",
  "cf.avgIncome": "Entrate medie",
  "cf.avgExpenses": "Uscite medie",
  "cf.avgNet": "Avanzo medio",
  "cf.perMo": "/mese",
  "cf.peak": "Picco: {month} ({amount})",
  "cf.maxExp": "Max uscite: {month} ({amount})",
  "cf.png": "PNG",

  "settings.dataMgmt": "Gestione e verifica dati",
  "settings.backupTitle": "Backup e ripristino",
  "settings.backupDesc":
    "Scarica un backup JSON di tutti i dati locali oppure ripristina da un export precedente.",
  "settings.pdfTitle": "Report annuale PDF",
  "settings.pdfDesc":
    "PDF offline su misura: copertina, KPI, flusso di cassa, budget, 50/30/20, debiti, fondi e patrimonio — con grafici incorporati.",
  "settings.currencyLocale": "Valuta e regione",
  "settings.theme": "Tema",
  "settings.helpSection": "Aiuto",
  "settings.openFaq": "Apri FAQ",
  "settings.currency": "Valuta",
  "settings.preview": "Anteprima",
  "settings.negative": "Negativo:",
  "settings.compact": "Compatto:",
  "settings.footer": "BudgetOS · Tutti i dati sono salvati localmente su questo dispositivo.",
  "settings.deleteCategory":
    "Eliminare questa categoria? Le transazioni mantengono gli importi ma perdono il collegamento.",
  "settings.deleteAccount": "Eliminare questo conto?",
  "settings.noCategories": "Nessuna categoria — aggiungine una sopra.",
  "settings.icon": "Icona",
  "settings.name": "Nome",
  "settings.monthlyTarget": "Obiettivo mensile",
  "settings.group": "Gruppo",
  "settings.accountNameLabel": "Nome del conto",
  "settings.openingBalance": "Saldo iniziale",
  "settings.type": "Tipo",
  "settings.perMonth": "{amount}/mese",
  "settings.categoryIcon": "Icona categoria",
  "settings.title": "Impostazioni",
  "settings.subtitle": "Personalizza aspetto, lingua, categorie e dati.",
  "settings.language": "Lingua",
  "settings.languageSection": "Lingua e regione",
  "settings.datePreview": "Anteprima data",
  "settings.timePreview": "Anteprima ora",
  "settings.currencyPreview": "Anteprima valuta",
  "settings.relativePreview": "Tempo relativo",
  "settings.categories": "Categorie",
  "settings.accounts": "Conti",
  "settings.restoreDefaults": "Ripristina categorie predefinite",
  "settings.restoreDefaultsConfirm":
    "Sostituire tutte le categorie con l'insieme predefinito (Spesa, Affitto, ecc.)? Le categorie personalizzate verranno rimosse.",
  "settings.addFirstAccount":
    "Aggiungi il primo conto per tracciare corrente, risparmi, debiti e attività.",
  "settings.loadDemo": "Carica dati demo",
  "settings.loadDemoDesc":
    "Cancella tutti i dati e popola 12 mesi di entrate, uscite, debiti e risparmi realistici.",
  "settings.loadDemoBtn": "Carica dati demo",
  "settings.loadingDemo": "Caricamento…",
  "settings.clearAll": "Cancella tutti i dati",
  "settings.clearAllDesc":
    "Elimina definitivamente transazioni, conti, debiti e fondi. Le categorie predefinite vengono ripristinate. Irreversibile.",
  "settings.clearConfirm": "Sì, elimina tutto",
  "settings.clearing": "Cancellazione…",
  "settings.clearedDone":
    "Dati personali cancellati. Categorie predefinite pronte — aggiungi un conto quando vuoi e registra le transazioni.",
  "settings.demoLoaded": "Dati demo caricati! 12 mesi di transazioni sono pronti.",
  "settings.calcCheck": "Verifica dei calcoli",
  "settings.runVerification": "Esegui script di verifica",
  "settings.calcCheckDesc":
    "Conferma che Dashboard, budget, calendario e regola 50/30/20 restano coerenti.",
  "settings.emptyAccounts": "Aggiungi il primo conto",
  "settings.categoryName": "Nome categoria",
  "settings.accountName": "es. Conto corrente",

  "theme.curated": "Look selezionati",
  "theme.fineTune": "Regola accento",
  "theme.corners": "Angoli",
  "theme.accent.default": "Blu oceano",
  "theme.accent.mint": "Menta pastello",
  "theme.accent.sand": "Sabbia calda",
  "theme.accent.midnight": "Mezzanotte",
  "theme.accent.cyberpunk": "Cyberpunk",
  "theme.radius.none": "Netto",
  "theme.radius.sm": "Sottile",
  "theme.radius.md": "Predefinito",
  "theme.radius.lg": "Arrotondato",
  "theme.radius.full": "Pillola",
  "theme.clean": "Clean",
  "theme.cleanBlurb": "Morbido e amichevole",
  "theme.fintech": "Fintech",
  "theme.fintechBlurb": "Denso e preciso",
  "theme.minimal": "Minimal",
  "theme.minimalBlurb": "Editoriale e calmo",
  "theme.forest": "Forest",
  "theme.forestBlurb": "Verde acqua e crema calda",

  "layout.brand": "BudgetOS",
  "layout.tagline": "Pianificatore annuale",
  "layout.collapse": "Comprimi",
  "app.loading": "Caricamento BudgetOS…",
  "app.newTx": "Aggiungi transazione",
  "app.help": "Aiuto",

  "print.tagline": "Budget annuale e patrimonio · Generato {date}",
  "print.footer": "Offline-first · i dati restano su questo dispositivo",

  "nw.month": "Mese",
  "nw.totalAssets": "Attività totali ({symbol})",
  "nw.totalDebts": "Debiti totali ({symbol})",
  "nw.title": "Monitoraggio patrimonio netto",
  "nw.logMonth": "Registra mese",
  "nw.current": "Patrimonio netto attuale",
  "nw.vsLastMonth": "vs mese precedente",
  "nw.assets": "Attività",
  "nw.debts": "Debiti",
  "nw.debtRatio": "Rapporto di indebitamento",
  "nw.monthsTracked": "Mesi registrati",
  "nw.logForm": "Registra patrimonio netto",
  "nw.trend": "Trend patrimonio netto",
  "nw.accounts": "Dettaglio conti",
  "nw.saveLog": "Salva registro",
  "nw.netWorth": "Patrimonio netto",

  "common.noData": "Nessun dato trovato",
  "common.add": "Aggiungi",
  "common.save": "Salva",
  "common.cancel": "Annulla",
  "common.delete": "Elimina",
  "common.edit": "Modifica",
  "common.close": "Chiudi",
  "common.export": "Esporta",
  "common.all": "Tutti",
  "common.person": "Persona",
  "common.year": "Anno",
  "common.loading": "Caricamento…",
  "common.newTransaction": "Nuova transazione",
  "common.uncategorized": "Senza categoria",
  "common.mainAccount": "Conto principale",

  "currency.USD": "Dollaro USA ($)",
  "currency.EUR": "Euro (€)",
  "currency.GBP": "Sterlina britannica (£)",
  "currency.CAD": "Dollaro canadese (CA$)",
  "currency.AUD": "Dollaro australiano (A$)",
  "currency.MXN": "Peso messicano (MX$)",
  "currency.JPY": "Yen giapponese (¥)",
  "currency.CHF": "Franco svizzero (CHF)",
  "currency.BRL": "Real brasiliano (R$)",
  "currency.INR": "Rupia indiana (₹)",

  "palette.mint": "Menta",
  "palette.sky": "Cielo",
  "palette.coral": "Corallo",
  "palette.lemon": "Limone",
  "palette.lavender": "Lavanda",

  // —— non-ui ——
  "nav.group.setup": "Configura una volta",
  "nav.group.daily": "Uso quotidiano",
  "nav.group.where": "Dove sei",
  "nav.group.wealth": "Costruisci patrimonio",
  "nav.dashboard": "Pannello",
  "nav.monthly": "Budget mensile",
  "nav.transactions": "Transazioni",
  "nav.calendar": "Calendario spese",
  "nav.rule503020": "Regola 50/30/20",
  "nav.networth": "Patrimonio netto",
  "nav.debt": "Estinzione debiti",
  "nav.sinking": "Fondi obiettivo",
  "nav.settings": "Impostazioni",
  "nav.bottom.home": "Inizio",
  "nav.bottom.log": "Registro",
  "nav.bottom.budget": "Budget",
  "nav.bottom.debt": "Debiti",
  "nav.bottom.wealth": "Patrimonio",

  "group.income": "Entrate",
  "group.needs": "Necessità",
  "group.wants": "Desideri",
  "group.savings": "Risparmi",

  "accountType.checking": "Corrente",
  "accountType.savings": "Risparmio",
  "accountType.asset": "Attività",
  "accountType.debt": "Debito",

  "cat.cat-sal": "Stipendio",
  "cat.cat-side": "Entrate extra",
  "cat.cat-div": "Dividendi",
  "cat.cat-rent": "Affitto / Mutuo",
  "cat.cat-util": "Utenze",
  "cat.cat-groc": "Spesa",
  "cat.cat-ins": "Assicurazioni",
  "cat.cat-trans": "Trasporti",
  "cat.cat-health": "Salute",
  "cat.cat-eat": "Ristoranti",
  "cat.cat-ent": "Intrattenimento",
  "cat.cat-shop": "Acquisti",
  "cat.cat-sub": "Abbonamenti",
  "cat.cat-travel": "Viaggi",
  "cat.cat-emerg": "Fondo emergenza",
  "cat.cat-invest": "Investimenti",
  "cat.cat-ret": "Pensione (401k)",

  "demo.acc-check": "Conto corrente Chase",
  "demo.acc-sav": "Risparmio HYSA",
  "demo.acc-cc1": "Carta Visa",
  "demo.acc-car": "Finanziamento auto",
  "demo.acc-inv": "Conto titoli",
  "demo.acc-401k": "401(k)",
  "demo.dbt-cc": "Carta Visa",
  "demo.dbt-car": "Finanziamento auto",
  "demo.dbt-sl": "Prestito studentesco",
  "demo.sf-hol": "Viaggio di vacanza",
  "demo.sf-emg": "Fondo emergenza",
  "demo.sf-car": "Acconto auto nuova",
  "demo.sf-home": "Riparazioni casa",
  "demo.sf-tech": "Nuovo laptop",
  "demo.note.overDining": "Cena con amici",
  "demo.note.workLunch": "Pranzo di lavoro",
  "demo.note.weekendOut": "Uscita del weekend",

  "qs.unzip.title": "Prima di iniziare: estrai la cartella",
  "qs.unzip.windows":
    "Windows: tasto destro sul file .zip -> \"Estrai tutto\" -> scegli dove salvarlo.",
  "qs.unzip.mac":
    "Mac: doppio clic sul file .zip - si estrae automaticamente accanto allo zip originale.",
  "qs.unzip.open":
    "Apri la cartella creata (stesso nome dello zip). All'interno trovi index.html, questa guida e una cartella chiamata assets.",
  "qs.unzip.warn":
    "Non spostare ne rinominare index.html separatamente, e non toglierlo da quella cartella - deve restare accanto alla cartella assets per funzionare.",

  "demo.banner":
    "Questa è una demo live di BudgetOS — dati di esempio, si reimposta a ogni visita.",
  "demo.readOnly":
    "Questa è una demo di anteprima. Le modifiche non vengono salvate — ottieni la versione completa su Etsy per il tuo budget.",
  "demo.cta": "Ottieni la versione completa",
  "demo.ctaHint": "Imposta VITE_ETSY_URL per collegare questo pulsante al listing Etsy.",

  "help.title": "Aiuto e FAQ",
  "help.close": "Chiudi aiuto",
  "help.replayTour": "Rivedi tour di avvio rapido",
  "help.quickStart": "Apri guida di avvio rapido (PDF)",
  "help.quickStartHtml": "Apri versione HTML",
  "help.q0": "Come funzionano backup e ripristino?",
  "help.a0":
    "Impostazioni → Backup e ripristino scarica un file JSON con ogni categoria, transazione, debito e fondo. Importa quel file nello stesso o in un altro browser per ripristinare i totali. Fai backup spesso — quel file è la tua unica copia portabile.",
  "help.q1": "Come sposto i dati su un nuovo dispositivo o browser?",
  "help.a1":
    "Esporta un backup sul vecchio dispositivo, apri BudgetOS sul nuovo e Importa backup. Fallo prima di cancellare i dati del sito o cambiare browser.",
  "help.q2": "Come reimposto tutti i dati?",
  "help.a2":
    "Impostazioni → Cancella tutti i dati elimina definitivamente transazioni, conti, debiti e fondi e ripristina le categorie predefinite. I conti non vengono ricreati. Un refresh non riporta la demo a meno che non tocchi Carica dati demo. Solo categorie: Ripristina categorie predefinite.",
  "help.q3": "Come cambio valuta o lingua?",
  "help.a3":
    "Impostazioni → Valuta per la formattazione. Impostazioni → Lingua e regione per la lingua dell'app. Gli importi salvati restano uguali.",
  "help.q4": "Funziona tutto offline?",
  "help.a4":
    "Sì. Una volta caricata l'app, BudgetOS non serve internet. Grafici, debiti, export e backup girano in locale.",
  "help.q5": "Quali browser sono supportati?",
  "help.a5":
    "Chrome, Firefox, Edge e Safari attuali. Usa un browser moderno con IndexedDB. La navigazione privata può cancellare i dati alla chiusura.",
  "help.q6": "Importante: non spostare il file HTML dopo aver salvato i dati",
  "help.a6":
    "Se apri BudgetOS via file:// (comune con download Etsy), alcuni browser — soprattutto Safari — legano lo storage a quel percorso. Esporta un backup prima di rinominare o spostare il file, poi reimporta dopo.",
  "help.q7": "Il PDF mostra un URL o una data nel margine — è un bug?",
  "help.a7":
    "Il report annuale e i PDF di sezione sono generati offline con jsPDF (non la finestra Stampa del browser), con intestazioni BudgetOS, numeri di pagina e grafici. Se usi comunque Stampa del browser, puoi disattivare intestazioni/piè di pagina nella finestra.",

  "tour.skip": "Salta",
  "tour.back": "Indietro",
  "tour.next": "Avanti",
  "tour.done": "Inizia",
  "tour.step": "Passo {n} di {total}",
  "tour.choice.eyebrow": "Benvenuto",
  "tour.choice.title": "Come vuoi iniziare?",
  "tour.choice.body":
    "Scegli una volta. Poi puoi caricare o cancellare la demo in Impostazioni.",
  "tour.choice.sample": "Esplora con dati di esempio",
  "tour.choice.sampleDesc": "Carica un anno realistico di demo per provare l’app.",
  "tour.choice.empty": "Inizia con i miei dati",
  "tour.choice.emptyDesc": "App vuota — solo categorie predefinite. Aggiungi la prima transazione quando vuoi.",
  "tour.s0.title": "I tuoi dati restano su questo dispositivo",
  "tour.s0.body":
    "BudgetOS è offline-first. Tutto è salvato in questo browser — nessun account, nessun cloud, nessun tracking.",
  "tour.s1.title": "Aggiungi una transazione quando vuoi",
  "tour.s1.body":
    "Tocca + (o Transazioni → Aggiungi) per registrare entrate o spese. I totali si aggiornano subito.",
  "tour.s2.title": "Impostazioni e backup",
  "tour.s2.body":
    "Apri Impostazioni per cambiare valuta, tema, categorie e scaricare un backup JSON. Esporta prima di cambiare browser.",
  "tour.s3.title": "Prova la demo quando vuoi",
  "tour.s3.body":
    "Impostazioni → Carica dati demo riempie un anno realistico. Cancella tutti i dati per passare ai tuoi numeri.",
  "tour.s4.title": "L'aiuto è sempre qui",
  "tour.s4.body": "Riapri questo tour o le FAQ dal pulsante ?. Sei pronto per il budget.",

  "empty.accounts.networth":
    "Aggiungi il primo conto in Impostazioni per vedere i saldi qui.",
  "empty.debts":
    "Nessun debito ancora. Carica la demo o aggiungi debiti quando configuri i conti — questa schermata resta pronta.",
  "empty.tx.noAccount":
    "Nessun conto ancora — puoi comunque salvare. Aggiungi il primo conto in Impostazioni quando vuoi.",

  "dash.yearGlance": "L'anno in sintesi — {year}",
  "dash.downloadReport": "Scarica report annuale",
  "dash.buildingPdf": "Creazione PDF…",
  "dash.savingsGoal": "Progresso obiettivo di risparmio",
  "dash.savingsRateTarget": "Tasso di risparmio · Obiettivo 20%",
  "dash.rateVsTarget": "Tasso vs obiettivo 20%",
  "dash.monthHighlights": "Highlight del mese",
  "dash.kpi.moneyIn": "Denaro in entrata",
  "dash.kpi.moneyOut": "Denaro in uscita",
  "dash.kpi.leftover": "Avanzo",
  "dash.kpi.savingsRate": "Tasso di risparmio",
  "dash.kpi.totalSaved": "Totale risparmiato",

  "pdf.tagline": "Pianificatore annuale offline",
  "pdf.cover.disclaimer":
    "Le cifre corrispondono ai calcoli BudgetOS a schermo. Generato interamente offline.",
  "pdf.generated": "Generato {date}",
  "pdf.page": "Pagina {n} di {total}",
  "pdf.view": "Vista: {person}",
  "pdf.title.annual": "Report annuale {year}",
  "pdf.period.detail": "Report annuale {year} · dettaglio {month}",
  "pdf.section.yearGlance": "L'anno in sintesi",
  "pdf.section.cashFlow": "Flusso di cassa mensile",
  "pdf.section.budget": "Budget mensile — {month} {year}",
  "pdf.section.rule": "Distribuzione 50/30/20",
  "pdf.section.debts": "Riepilogo debiti",
  "pdf.section.funds": "Fondi obiettivo",
  "pdf.section.netWorth": "Patrimonio netto",
  "pdf.col.kpi": "KPI",
  "pdf.col.value": "Valore",
  "pdf.col.month": "Mese",
  "pdf.col.in": "Entrate",
  "pdf.col.out": "Uscite",
  "pdf.col.leftover": "Avanzo",
  "pdf.col.category": "Categoria",
  "pdf.col.target": "Obiettivo",
  "pdf.col.actual": "Effettivo",
  "pdf.col.variance": "Scostamento",
  "pdf.col.group": "Gruppo",
  "pdf.col.bucket": "Voce",
  "pdf.col.amount": "Importo",
  "pdf.col.pctIncome": "% del reddito",
  "pdf.col.targetPct": "% obiettivo",
  "pdf.col.debt": "Debito",
  "pdf.col.balance": "Saldo",
  "pdf.col.apr": "TAN",
  "pdf.col.interest": "Interessi",
  "pdf.col.months": "Mesi",
  "pdf.col.payoff": "Estinzione",
  "pdf.col.fund": "Fondo",
  "pdf.col.saved": "Risparmiato",
  "pdf.col.progress": "Progresso",
  "pdf.col.moNeeded": "Serve/mese",
  "pdf.col.assets": "Attività",
  "pdf.col.debts": "Debiti",
  "pdf.col.net": "Netto",
  "pdf.col.account": "Conto",
  "pdf.col.type": "Tipo",
  "pdf.col.payment": "Pagamento",
  "pdf.col.principal": "Capitale",
  "pdf.sub.incomeSources": "Fonti di entrata",
  "pdf.sub.nws": "Necessità / Desideri / Risparmi",
  "pdf.sub.expenseCats": "Categorie di spesa",
  "pdf.sub.accounts": "Dettaglio conti",
  "pdf.kpi.moneyIn": "Denaro in entrata",
  "pdf.kpi.moneyOut": "Denaro in uscita",
  "pdf.kpi.leftover": "Avanzo",
  "pdf.kpi.savingsRate": "Tasso di risparmio",
  "pdf.kpi.totalSaved": "Totale risparmiato",
  "pdf.savingsGoal": "Obiettivo di risparmio: {actual} / {target}",
  "pdf.debtSummary":
    "Debito totale {debt} · Interessi totali {interest} · Senza debiti {date}",
  "pdf.nwSummary": "Netto {net} · Attività {assets} · Debiti {debts}",
  "pdf.empty.debts": "Nessun debito registrato.",
  "pdf.empty.funds": "Nessun fondo obiettivo registrato.",
  "pdf.empty.chart": "Nessun grafico disponibile per questo periodo.",
  "pdf.empty.rule":
    "Nessuna distribuzione delle spese in questo periodo — i valori effettivi sono 0.",
  "pdf.chart.cashFlow": "Flusso di cassa mensile",
  "pdf.chart.income": "Entrate",
  "pdf.chart.expense": "Uscite",
  "pdf.chart.rule": "50/30/20 · {month} {year}",
  "pdf.chart.netWorthTrend": "Trend patrimonio netto",
  "pdf.chart.netWorth": "Patrimonio netto",
  "pdf.chart.assets": "Attività",
  "pdf.chart.debts": "Debiti",
  "pdf.chart.emptySpend": "Nessuna spesa in questo periodo",
  "pdf.chart.emptyHint":
    "Necessità / Desideri / Risparmi compariranno quando questo mese avrà spese.",
  "pdf.amortization": "Ammortamento — {name}",
  "pdf.payoffInterest": "Estinzione {date} · Interessi {interest}",
};
